'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
type UseInViewOptions = {
  rootMargin?: string;
  threshold?: number | number[];
  once?: boolean;
};
export function useInView(t0) {
  const $ = _c(10);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    rootMargin: t2,
    threshold: t3,
    once: t4
  } = options;
  const rootMargin = t2 === undefined ? "200px 0px" : t2;
  const threshold = t3 === undefined ? 0 : t3;
  const once = t4 === undefined ? true : t4;
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  let t5;
  let t6;
  if ($[2] !== inView || $[3] !== once || $[4] !== rootMargin || $[5] !== threshold) {
    t5 = () => {
      const element = ref.current;
      if (!element) {
        return;
      }
      if (once && inView) {
        return;
      }
      const observer = new IntersectionObserver(t7 => {
        const [entry] = t7;
        if (!entry) {
          return;
        }
        if (entry.isIntersecting) {
          setInView(true);
          if (once) {
            observer.disconnect();
          }
        } else {
          if (!once) {
            setInView(false);
          }
        }
      }, {
        root: null,
        rootMargin,
        threshold
      });
      observer.observe(element);
      return () => observer.disconnect();
    };
    t6 = [inView, once, rootMargin, threshold];
    $[2] = inView;
    $[3] = once;
    $[4] = rootMargin;
    $[5] = threshold;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  if ($[8] !== inView) {
    t7 = [ref, inView];
    $[8] = inView;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7 as const;
}